import { colors } from "styles/color-tokens";

export function CollectionColor({
  className,
  collection,
}: {
  className?: string;
  collection: { preferences?: { color: string } };
}) {
  return (
    <span
      style={{
        backgroundColor: collection.preferences?.color ?? colors.neutral400,
      }}
      className={`inline-block size-2.5 rounded transition-colors duration-500 ${className ?? ""}`}
    />
  );
}
